var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.113 15.45v-2.28a5.297 5.297 0 0 1-2.958-4.733 5.284 5.284 0 0 1 5.282-5.282c3.295 0 5.662 2.366 5.662 5.282-.001.718-.17 1.436-.508 2.281l-.93-3.042-1.86.592 1.649 6.295 6.423-2.366-.803-1.86-2.408.804c.422-.929.507-1.647.507-2.746C24.17 4.296 20.872 1 16.393 1A7.376 7.376 0 0 0 9 8.394c.042 3.296 2.155 6.085 5.113 7.057zm1.225-9h2.197v19.1h-2.197V6.45zm3.423 12.38v-2.28c2.958.971 5.07 3.76 5.113 7.056A7.375 7.375 0 0 1 16.48 31c-4.48 0-7.776-3.296-7.776-7.394 0-1.1.085-1.817.507-2.747l-2.407.802L6 19.802l6.422-2.365 1.648 6.295-1.859.592-.928-3.042c-.338.845-.507 1.563-.507 2.281 0 2.916 2.366 5.282 5.662 5.282a5.284 5.284 0 0 0 5.281-5.282 5.296 5.296 0 0 0-2.957-4.732z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYfi);
export default __webpack_public_path__ + "static/media/YFI.a62432b9fd29baa91b86e11e8f7bab80.svg";
export { ForwardRef as ReactComponent };